// CommonIn.js      

const CommonIn = () => {
        //서브 헤더 
        const submenu = document.querySelector('.submenu');
        var submenuOffset,mediaQuery,lastScrollY;
        if(submenu!=null){
            submenuOffset = submenu.offsetTop;
            // const menuLinks = document.querySelectorAll('.submenu a');
            // const sections = Array.from(menuLinks).map(link => document.querySelector(link.getAttribute('href')));
            mediaQuery = window.matchMedia('(max-width: 768px)');
    
            lastScrollY = window.scrollY;

            //scroll 이벤트는 오직 하나만
            window.addEventListener('scroll', handleScroll);

            //화면 크기 변경에도 즉시 반응
            mediaQuery.addEventListener('change', handleScroll);
    
        }

        // 스크롤 이벤트 등록
        window.addEventListener('scroll', handleScroll);

        function handleScroll() {
            const submenuEl = document.querySelector('.submenu');

            if (!submenuEl) return; // .submenu가 없으면 함수 종료

            const currentScrollY = window.scrollY;
            const submenuOffset = submenuEl.offsetTop;

            if (currentScrollY >= submenuOffset) {
                submenuEl.classList.add('fixed'); // 변수 이름 수정
            } else {
                submenuEl.classList.remove('fixed'); // 변수 이름 수정
            }


            // 3. 네임링크때 서브메뉴
            const sections = document.querySelectorAll('.snlink');
            const menuLinks = document.querySelectorAll('.submenu_inner a');

            let currentSectionIndex = -1;
            const currentScrollCenter = window.scrollY + (window.innerHeight / 2);

            sections.forEach((section, i) => {
                const top = section.offsetTop;
                const bottom = top + section.offsetHeight;
                if (currentScrollCenter >= top && currentScrollCenter < bottom) {
                    currentSectionIndex = i;
                }
            });

            if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - 2) {
                currentSectionIndex = sections.length - 1;
            }

            menuLinks.forEach((link, idx) => {
                link.classList.toggle('active', idx === currentSectionIndex);
            });
        }

        

        //모바일 헤더
        const hamburger = document.querySelector('.hamburger');

        hamburger.addEventListener('click', function () {
            this.classList.toggle('active');
            const mobileMenu = document.querySelector('.mobile_menu');            
            mobileMenu.classList.toggle('open');
    //   hamburger.classList.toggle('active'); // 햄버거 애니메이션용

            // aria-expanded 업데이트도 함께 해줌
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!isExpanded));
        });


        //서브페이지 헤더
        document.addEventListener("DOMContentLoaded", function() {
            // const currentPath = window.location.pathname; // 현재 경로 예: /business/index.html

            // const menuLinks = document.querySelectorAll(".main_nav .main_menu a");

            // menuLinks.forEach(link => {
            //     const linkHref = link.getAttribute("href"); // 메뉴의 href 예: /business/index.html

            //     // 현재 경로가 메뉴 href로 끝나면 active
            //     if (linkHref && currentPath.endsWith(linkHref)) {
            //         link.classList.add("active");
            //     }
            // });
        });

        //faq
        function toggleAccordion(header) {
            const content = header.nextElementSibling;
            const arrow = header.querySelector(".arrow");
            
            content.classList.toggle("active");
            arrow.classList.toggle("rotated");
        }

        //btn_top
        function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        }

        return {
            toggleAccordion,
            scrollToTop
        };


};

export default CommonIn;
